module.exports = __webpack_public_path__ + "img/26f65a7.webp";